import styled from "styled-components";

export const SCreateProjectModalFirstStepItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  text-align: center;
`;
